module.exports = __webpack_public_path__ + "static/media/facebook.3ddb4b5b.svg";